module.exports = __webpack_public_path__ + "static/media/1.cea340da.svg";